module.exports = __webpack_public_path__ + "img/1920_icon_error.1ac87c14.svg";